import { Form } from "react-bootstrap";
import ReactDatetime from "react-datetime";
import moment from "moment";
import "moment/locale/el";
import { useEffect } from "react";

import { useTranslation } from "react-i18next";

moment.locale("el");

function DatetimeSelect({
  title,
  handler,
  value,
  dateFormat = "DD/MM/YYYY",
  timeFormat = "HH:mm",
  returnFormat = "DD/MM/YYYY HH:mm",
}) {
  const {
    t,
  } = useTranslation();

  title = title === undefined ? t("forms.placeholders.selectDate") : title;
  const changeDate = (e) => {
    let myDateObject = e;
    const momentObject = moment(e);
    if (!momentObject.isValid()) myDateObject = moment().startOf("day");
    handler(myDateObject.format(returnFormat));
  };

  return (
    <Form.Group>
      <h5 className="title">{title}</h5>
      <ReactDatetime
        initialValue={value}
        dateFormat={dateFormat}
        timeFormat={timeFormat}
        inputProps={{
          className: "form-control",
          placeholder: title,
        }}
        onChange={changeDate}
        closeOnSelect={true}
      ></ReactDatetime>
    </Form.Group>
  );
}

export default DatetimeSelect;
